import { perform } from 'src/app/api'
import { GetAccount, GetAccountData } from 'src/legacy_graphql'
import useActions from './useActions'
import usePersistedUserData from './usePersistedUserData'

export const useForceAccountRefresh = () => {
  const actions = useActions()
  const { controlData } = usePersistedUserData()

  if (!controlData.token)
    return async () => {
      return
    }

  return async () => {
    const result = await perform<GetAccountData>(GetAccount())
    actions.refreshedAccount(result.account)
  }
}
